import {Pipe, PipeTransform} from "@angular/core";
import {IPersonName} from "../interfaces/person.name";
import {PatientUtilsService} from "../../patient.utils/services/patient.utils.service";

@Pipe({name: 'cpName'})
export class NamePipe implements PipeTransform {
	constructor(private patientUils:PatientUtilsService) {
	}

	transform(value: IPersonName, patientMode:boolean=false) : string {
		if (patientMode){
			return this.patientUils.getFullNameObj(value);
		}else {
			let parts = [];

			if (value.lastName) {
				parts.push(value.lastName);
			}

			if (value.firstName || value.middleName) {
				if (!value.firstName) {
					parts.push(value.middleName);
				} else if (!value.middleName) {
					parts.push(value.firstName);
				} else {
					parts.push(value.firstName + ' ' + value.middleName);
				}
			}

			return parts.join(', ');
		}
	}
}
